import React from 'react';
import T from 'prop-types';

const TotalCount = ({ publisher, totalCount, displayedCount = 3 }) => {
  if (!totalCount || totalCount <= displayedCount) return null;

  return (
    <div className="total-count">
      <a
        className="text-underline text-blue"
        href={`/publishers/${publisher.store}/${publisher.ref_no}`}
      >
        {`+ ${totalCount - displayedCount} More`}
      </a>
    </div>
  );
};

TotalCount.propTypes = {
  publisher: T.object.isRequired,
  totalCount: T.number,
  displayedCount: T.number,
};

export default TotalCount;
